import * as React from "react";

const SVGComponent = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.8 8L4 3L12 8L4 13L6.8 8Z"
        fill={props.color || "#4F4F4F"}
        stroke={props.color || "#4F4F4F"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SVGComponent;
